module.exports = __webpack_public_path__ + "brand-icons.fdb3df0ffc5e9b999e9c.woff";


//////////////////
// WEBPACK FOOTER
// /app/src/fonts/brand-icons/brand-icons.woff?v=0.3.2
// module id = ../../../../../src/fonts/brand-icons/brand-icons.woff?v=0.3.2
// module chunks = 5